import styled from 'styled-components';
import { theme } from 'modules/ui/theme';

export const StyledPaginationContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

export const StyledTableFooter = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  width: 100%;
  margin: 0 0 2.625rem 0;
`;

export const StyledPageList = styled.ul`
  list-style-type: none;
  display: flex;
  align-items: baseline;
  justify-content: start;
  margin: 0 0.4rem;
  padding: 0.2rem 0 0 0;
  color: ${({theme}) => theme.colors.primaryK10};
    
  li {
    margin: 0 0.4rem;

    &.dots:hover {
      cursor: default;
    }
  }
`;
